import ProviderLanguage from "@wtw/company-portal/lib/i18n/ProviderLanguage";

export function initializeProviderLanguage() {
    (window as any).providerLanguage = {
        en: require('./locales/en.json'),
        nn: require('./locales/nn.json'),
        no: require('./locales/no.json')
    } as ProviderLanguage;
}